import React, { FC } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import { AutoTagging } from '../../../components/forms/autocomplete/AutoTagging'

type IBaseControllerProps = ControllerProps<React.ComponentType>

export interface IControlledAutoTaggingInputProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue'> {
  AutoTaggingInputProps?: any
}

const ControlledAutoTaggingInput: FC<IControlledAutoTaggingInputProps> = ({
  name,
  control,
  defaultValue = '',
  AutoTaggingInputProps = {},
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ onBlur, onChange, value }) => {
        return (
          <AutoTagging
            {...AutoTaggingInputProps}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
          />
        )
      }}
    />
  )
}

export default ControlledAutoTaggingInput
